import { baseDeleteQuery } from '../../../../utility/sb-api/sb-api.service';

export const deleteCategory = (id, storeId, onSuccessCallback) =>
  baseDeleteQuery(
    `manager/stores/${storeId}/item-categories/${id}`,
    null,
    'removeCategorySuccess',
    'removeCategoryError',
  ).then(onSuccessCallback);
